import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import qs from "querystring";
import { addUid } from '../../actions/WelcomeActions';
import { hideSplash } from '../../actions/SplashScreenActions';
import { checkAccess } from '../../actions/WelcomeActions';
import { getDetails, getInterests } from '../../actions/AccountActions';
import * as vars from '../../constants/variables';
import { console_log, parseQueryString, appendUid, getParameters } from '../../utils/helper';
import { FormattedMessage } from 'react-intl';
import { config } from '../../constants/domainConfig';
import {isGamiclub} from './../../constants/isGamiclub'
import { getCategories } from "../../actions/CategoryActions";
import { getGames} from "../../actions/GamesActions";
import { getDomainTheme } from "../../utils/domainTheme";
class SplashScreen extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const uid = getParameters("uid");
        const msisdn = getParameters("msisdn");
        const rid = getParameters("rid");
        const id = getParameters("id");
        const is_staging = getParameters("is_staging")
        let search = {}
        if(uid.exist){
            this.props.addUid({uid: uid.value})
        }
        if(is_staging.exist) search = {...search, is_staging: is_staging.value}
        if (this.props.location.pathname === '/') {
            if(config.subDomain === "kw" && isGamiclub && id.exist){
                search = {...search, id: id.value}
                this.props.history.push({
                    pathname: "/welcome",
                    search: qs.stringify(search)
                });
            }
            else if(config.subDomain === "za" && uid.exist && rid.exist){
                search = {...search, uid: uid.value, rid: rid.value}
                this.props.history.push({
                    pathname: "/welcome",
                    search: qs.stringify(search)
                });
            }
            else if(config.subDomain === "sa" && !isGamiclub && id.exist){
                search = {...search, id: id.value}
                this.props.history.push({
                    pathname: "/welcome",
                    search: qs.stringify(search)
                });
            }
            else if (config.subDomain == 'mase'  || config.subDomain == 'th' || config.subDomain === "rsma" || (window.location.hostname.includes('game-lords.com') && config.subDomain === 'ae') || window.location.hostname.includes('vplay')) {
                search = {...search, uid: uid.value}
                this.props.history.push({
                    pathname: "/home/html",
                    search: qs.stringify(search)
                });            
            }
            else if (config.subDomain == 'pk') {
                search = {...search, uid: uid.value}
                this.props.history.push({
                    pathname: "/home/android",
                    search: qs.stringify(search)
                });    
            }
            else if (msisdn.exist) {
                search = {...search, msisdn: msisdn.value}
                this.props.history.push({
                    pathname: "/welcome",
                    search: qs.stringify(search)
                });
            }
            else if(rid.exist){
                search = {...search, rid: rid.value}
                this.props.history.push({
                    pathname: "/welcome",
                    search: qs.stringify(search)
                });
            }
            else {
                search = {...search, uid: uid.value}
                this.props.history.push({
                    pathname: "/welcome",
                    search: qs.stringify(search)
                });    
            }
        } else {
            this.props.history.push(this.props.location.pathname + this.props.location.search);
        }
    }

    render() {
        const theme = getDomainTheme();
        let className = "splash-screen";
        if (this.props.splash.hideSplash) {
            className += " hidden";
        }
        return (
            <div className={className}>
                <div className="splash-screen__image-wrap">
                    <img className="splash-screen__image img-fluid" src={theme.logo} alt={theme.productName} />
                </div>
                <p className="splash-screen__text">
                    <FormattedMessage id="splashscreen.text"
                        defaultMessage="Play Way Beyond"
                        description="Splashscreen text"
                    />
                </p>
            </div>
        )

    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        splash: state.SplashScreenReducer,
        account: state.AccountReducer,

    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
      {
        getCategories,
        getGames,
        hideSplash,
        checkAccess,
        addUid,
        getDetails,
        getInterests,
      },
      dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SplashScreen);



// WEBPACK FOOTER //
// ./src/components/SplashScreen/SplashScreen.js